export const transportEntitiesCollectionGuard = 'GET /v2/transport-entities';
export const transportEntitiesTypesCollectionGuard =
  'GET /v2/transport-entities-types';
export const transportEntitiesResourceGuard = 'GET /v2/transport-entities/d+';
export const transportEntitiesRegExpCollectionGuard =
  'GET /v2/transport-entities/[a-zA-Z0-9- ]+';
export const editTransportEntitiesResourceGuard =
  'PUT /v2/transport-entities/d+';
export const createTransportEntitiesResourceGuard =
  'POST /v2/transport-entities';
export const deleteTransportEntitiesResourceGuard =
  'DELETE /v2/transport-entities/d+';
